import { type EffectCallback, useEffect, useRef } from 'react';

function useMountEffect(callback: EffectCallback) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => callbackRef.current(), []);
}

export default useMountEffect;
